"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileImageUpload = require("../elements/ProfileImageUpload");

var _ProfileImageUpload2 = _interopRequireDefault(_ProfileImageUpload);

var _DeleteConfirmation = require("../menu/DeleteConfirmation");

var _DeleteConfirmation2 = _interopRequireDefault(_DeleteConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = require("moment");

exports.default = {
  props: ["units", "profilePictureUrl", "delete_account_requested_at"],

  components: {
    ProfileImageUpload: _ProfileImageUpload2.default,
    DeleteConfirmation: _DeleteConfirmation2.default
  },

  data: function data() {
    return {
      editing: false,
      deleting: false,
      user: window.globals.user,
      errors: [],
      oldInput: []
    };
  },
  mounted: function mounted() {
    if (this.$store.state.requestErrors["profile"] !== undefined) {
      this.editing = true;
    }

    var requestData = this.$store.getters.pullRequestErrorsAndOldInputByAction("profile");
    this.errors = requestData.errors;
    this.oldInput = requestData.oldInput;
    this.$parent.$emit("editing", this.editing);
  },


  methods: {
    cancelDeleting: function cancelDeleting() {
      this.deleting = false;
    }
  },

  computed: {
    showDeleteButton: function showDeleteButton() {
      return !this.delete_account_requested_at || moment(this.delete_account_requested_at).diff(moment(), "hours") <= -24;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/ProfileMenu.vue
// module id = KKrc
// module chunks = 0 1